/* eslint-disable */
import { NotificationManager } from "react-notifications";

export function ErrorHandelFunctionApp(error){

    if(error?.response?.data){
        NotificationManager.error(error?.response?.data?.message);
    }else{
        NotificationManager.error("الخادم غير متوفر");
    }
}